import { TableHeader } from '@/models/TableHeader';
import { NFCInformations } from '@/models/NFCInformations';
import { SortType } from '@/models/SortType';
import { Site } from '@/models/Site';
import { NFCHistorique } from '@/models/NFCHistorique';

export interface NFCState {
    tableHeader: TableHeader[];
    historiqueTableHeader: TableHeader[];
    page: number;
    nbOfPages: number;
    scroll: number;
    count: number;
    NFC: NFCInformations[];
    sort?: {
        sortData: string;
        sortStatus: SortType;
    };
    isLoading: boolean;
    filterSite: Site[];
    filterLocalisation: string;
    error?: Error;
    nfcHistorique: NFCHistorique[];
    numeroNFC: number;
    sortHistorique?: {
        sortData: string;
        sortStatus: SortType;
    };
    nbOfHistoriquePages: number;
    historiquePage: number;
    historiqueScroll: number;
    isHistoriqueLoading: boolean;
}

export const initialState: NFCState = {
    NFC: [],
    tableHeader: [
        {
            label: 'administratif.data.NFCAdresse',
            sortData: 'adresse',
            sortStatus: SortType.NONE,
            width: '30%',
        },
        {
            label: 'administratif.data.NFCNumero',
            sortData: 'numeroNfc',
            sortStatus: SortType.NONE,
            width: '20%',
        },
        {
            label: 'administratif.data.NFCLocalisation',
            sortData: 'localisation',
            sortStatus: SortType.NONE,
            width: '20%',
        },
        {
            label: 'administratif.data.NFCSite',
            sortData: 'chantier',
            sortStatus: SortType.NONE,
            width: '30%',
        }
    ],
    historiqueTableHeader: [
        {
            label: 'nfc.historique.adresse',
            sortData: 'adresse',
            sortStatus: SortType.NONE,
            width: '55%',
        },
        {
            label: 'nfc.historique.localisation',
            sortData: 'localisation',
            sortStatus: SortType.NONE,
            width: '25%',
        },
        {
            label: 'nfc.historique.dateCreation',
            sortData: 'dateCreation',
            sortStatus: SortType.NONE,
            width: '20%',
        }
    ],
    page: 0,
    nbOfPages: 0,
    scroll: 0,
    count: 0,

    sort: {
        sortData: 'id',
        sortStatus: SortType.DESC,
    },

    filterSite: [],
    filterLocalisation: '',

    isLoading: false,
    nfcHistorique: [],
    numeroNFC: 0,
    sortHistorique: {
        sortData: 'dateCreation',
        sortStatus: SortType.DESC,
    },
    nbOfHistoriquePages: 0,
    historiquePage: 0,
    historiqueScroll: 0,
    isHistoriqueLoading: false
};

export const state: NFCState = {
    ...initialState
};
